import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    question: '',
    hint: '',
    remainTime: 0
  },
  getters: {},
  mutations: {
    changeQuest (state, payload) {
      state.question = payload
    },
    changeHint (state, payload) {
      state.hint = payload
    },
    countDown (state, payload) {
      state.remainTime = payload
    }
  },
  actions: {}
})
